import { applyMiddleware, createStore } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly'
import createSagaMiddleware from 'redux-saga'
import { persistStore, autoRehydrate } from 'redux-persist'
import localForage from 'localforage'

import apolloClient from './apolloClient'
import reducer from './reducer'
import saga from './saga'

const BLACKLIST = ['apollo']

const sagaMiddleware = createSagaMiddleware()

export default function configureStore() {
  const store = createStore(
    reducer,
    composeWithDevTools(
      applyMiddleware(apolloClient.middleware(), sagaMiddleware),
      autoRehydrate()
    )
  )

  sagaMiddleware.run(saga)

  if (module.hot) {
    module.hot.accept('./reducer', () => {
      // eslint-disable-next-line global-require
      const nextReducer = require('./reducer').default

      store.replaceReducer(nextReducer)
    })
  }

  persistStore(store, {
    blacklist: BLACKLIST,
    storage: localForage
  })

  return store
}



// WEBPACK FOOTER //
// ./client/base/configureStore.js